import { GradientBackground } from "panels/routing/PilotTracking/GradientBackground"

export const BetaTag = () => {
    return (
        <GradientBackground borderWidth={1} className="rounded-full">
            <small className="xxs bg-black-1000 py-0.5 px-1 rounded-full flex items-center gap-4 h-full">
                Beta
            </small>
        </GradientBackground>
    )
}
